/**
 * frontend/lib/supabaseClient.js
 * Supabase browser client — singleton used across all frontend components.
 *
 * Reads from environment variables (Create React App requires REACT_APP_ prefix).
 * Add to frontend/.env.local:
 *   REACT_APP_SUPABASE_URL=https://your-project.supabase.co
 *   REACT_APP_SUPABASE_ANON_KEY=your-anon-key
 */

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL      = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn(
    '[supabase] Missing env vars. Add REACT_APP_SUPABASE_URL and ' +
    'REACT_APP_SUPABASE_ANON_KEY to frontend/.env.local'
  );
}

export const supabase = createClient(
  SUPABASE_URL  || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder-key',
  {
    auth: {
      flowType:           'implicit', // magic links work across devices/tabs/email clients
      autoRefreshToken:   true,
      persistSession:     true,
      detectSessionInUrl: true,       // required for magic link callback
    },
  }
);
